import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

const gutLabel = (value) => {
  if (value <= 10) return "Baixa";
  if (value <= 40) return "Moderada";
  if (value <= 75) return "Alta";
  return "Crítica";
};

const StepClassificacaoMetodologica = ({ classificacao, onChange, onSave, readOnly }) => {
  const data = classificacao || {};
  const gut = (data.gut_gravidade || 1) * (data.gut_urgencia || 1) * (data.gut_tendencia || 1);
  const update = (field, value) => onChange({ ...data, [field]: value });

  return (
    <Card>
      <CardHeader><CardTitle>Classificação Metodológica</CardTitle></CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-2">
          <Label>Estado Aparente de Desempenho</Label>
          <Input value={data.estado_aparente || ""} disabled={readOnly} onChange={(e) => update("estado_aparente", e.target.value)} placeholder="Classe 1, 2 ou 3" />
          <Textarea value={data.justificativa_estado_aparente || ""} disabled={readOnly} onChange={(e) => update("justificativa_estado_aparente", e.target.value)} placeholder="Justificativa técnica" />
        </div>
        <div className="space-y-2">
          <Label>Classificação de Prioridade (NBR 16747)</Label>
          <Input value={data.prioridade_nbr_16747 || ""} disabled={readOnly} onChange={(e) => update("prioridade_nbr_16747", e.target.value)} placeholder="Prioridade 1, 2 ou 3" />
          <Textarea value={data.fundamentacao_prioridade || ""} disabled={readOnly} onChange={(e) => update("fundamentacao_prioridade", e.target.value)} placeholder="Fundamentação técnica" />
        </div>
        <div className="space-y-2">
          <Label>Matriz GUT</Label>
          <div className="grid grid-cols-3 gap-3">
            <Input type="number" min="1" max="5" value={data.gut_gravidade || 1} disabled={readOnly} onChange={(e) => update("gut_gravidade", Number(e.target.value))} />
            <Input type="number" min="1" max="5" value={data.gut_urgencia || 1} disabled={readOnly} onChange={(e) => update("gut_urgencia", Number(e.target.value))} />
            <Input type="number" min="1" max="5" value={data.gut_tendencia || 1} disabled={readOnly} onChange={(e) => update("gut_tendencia", Number(e.target.value))} />
          </div>
          <div className="rounded-lg bg-[#F5F2EB] px-4 py-3 text-sm">Índice GUT: <strong>{gut}</strong> ({gutLabel(gut)})</div>
          <Textarea value={data.gut_justificativa || ""} disabled={readOnly} onChange={(e) => update("gut_justificativa", e.target.value)} placeholder="Justificativa técnica" />
        </div>
        {!readOnly && <Button onClick={onSave}>Salvar</Button>}
      </CardContent>
    </Card>
  );
};

export default StepClassificacaoMetodologica;
